import { makeStyles } from "@mui/styles";
import LOGO from "@/assets/black_logo.png";

const useStyles = makeStyles({
  lawInfoWrapper: {
    position: "relative",
    width: "100vw",
    height: "100vh",
  },
  footer: {
    width: "100vw",
    position: "absolute",
    bottom: 0,
    left: 0,
    height: "5vh",
    background: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  footerLogo: {
    height: "100%",
  },
  content: {
    width: "100%",
    maxWidth: "680px",
    padding: 16,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxSizing: "border-box",
  },
  innerContent: {
    padding: 16,
    border: "1px solid #eee",
  },
  text: {
    margin: "0 0 16px",
  },
});

const LawInfo = () => {
  const classes = useStyles();

  return (
    <div className={classes.lawInfoWrapper}>
      <div className={classes.content}>
        <div className={classes.innerContent}>
          <p className={classes.text}>Dear Merchant,</p>
          <p className={classes.text}>
            If you've decided to opt out and no longer want to receive Reserve
            with Google through MenuSifu, simply send an email to our customer
            service at
            <a href="mailto:assist@menusifu.com"> assist@menusifu.com</a>.
            Alternatively, you can reach out to your dedicated customer service
            assistant via group chat.
          </p>
          <p className={classes.text}>
            Upon receiving your request, we will promptly get in touch with you
            and process the opt-out within 5 working days.
          </p>
          <p className={classes.text}>
            We appreciate your support and understanding.
          </p>
        </div>
      </div>
      <footer className={classes.footer}>
        <img
          className={classes.footerLogo}
          src={LOGO}
          alt="logo"
          onClick={() =>
            window.open("https://www.menusifu.com/cn/home", "_blank")
          }
        />
      </footer>
    </div>
  );
};

export default LawInfo;
